import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.logs');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-logs',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.logs/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class PageKieraLogsComponent implements OnInit, OnDestroy {
    public services: any[] = [];
    public selectedService: string = '';
    public logs: any[] = [];
    public serviceView: string = 'logs';
    public serviceYaml: string = '';
    public logMode: string = 'services';
    public logSources: any[] = [];
    public logPresets: any[] = [];
    public selectedSource: string = '';
    public asyncEventsEnabled: boolean = true;
    public sourceLogs: any[] = [];
    public sourceFiles: any[] = [];
    public sourceMessage: string = '';
    public eventEnvelopes: any[] = [];
    public eventSummary: any = { total: 0, sources: {}, severities: {}, topics: {} };
    public eventTopics: any[] = [];
    public eventSourceFilter: string = '';
    public eventTraceFilter: string = '';
    public eventTopicFilter: string = '';
    public eventSeverityFilter: string = 'all';
    public nodeFilter: string = '';
    public deploymentJobFilter: string = '';
    public logLines: number = 200;
    public loading: boolean = false;
    public loadingLogs: boolean = false;
    public loadingYaml: boolean = false;
    public autoRefresh: boolean = false;
    public levelFilter: string = 'all';
    public operationQueueSummary: any = { statuses: {}, active_by_kind: {}, latest_attention: [] };

    private refreshTimer: any = null;
    private statusTimer: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("bootstrap");
            if (code === 200) {
                this.services = data.services || [];
                this.operationQueueSummary = data.summary || { statuses: {}, active_by_kind: {}, latest_attention: [] };
                this.applyLogSources(data);
            }
        } catch (e) { }
        this.loading = false;
        await this.service.render();
        this.loadServiceResources();
    }

    ngOnDestroy() {
        this.stopAutoRefresh();
        this.stopStatusTimer();
    }

    public async loadServices(forceRefresh: boolean = false) {
        this.loading = true;
        await this.service.render();
        try {
            const [serviceResult, resourceResult] = await Promise.all([
                wiz.call("service_list", { refresh: forceRefresh ? 1 : 0 }),
                wiz.call("service_resources")
            ]);
            if (serviceResult.code === 200) this.services = serviceResult.data.services || [];
            if (resourceResult.code === 200) this.applyServiceResources(resourceResult.data.resources || {});
        } catch (e) { }
        this.loading = false;
        await this.service.render();
    }

    private applyServiceResources(resources: any) {
        for (const item of this.services) {
            if (item?.container && resources[item.container] !== undefined) {
                item.memory = resources[item.container];
            }
        }
    }

    public async loadServiceResources() {
        try {
            const { code, data } = await wiz.call("service_resources");
            if (code === 200) this.applyServiceResources(data.resources || {});
        } catch (e) { }
        await this.service.render();
    }

    public async loadOperationQueueSummary() {
        try {
            const { code, data } = await wiz.call("operation_queue_summary");
            if (code === 200) this.operationQueueSummary = data.summary || { statuses: {}, active_by_kind: {}, latest_attention: [] };
        } catch (e) { }
        await this.service.render();
    }

    public async refreshServicePane() {
        await Promise.all([
            this.loadServices(true),
            this.loadOperationQueueSummary()
        ]);
    }

    public async loadLogSources() {
        try {
            const { code, data } = await wiz.call("log_sources");
            if (code === 200) this.applyLogSources(data);
        } catch (e) { }
        await this.service.render();
    }

    private applyLogSources(data: any) {
        this.logSources = data?.sources || [];
        this.logPresets = data?.presets || [];
        this.asyncEventsEnabled = data?.log_policy?.async_events !== false;
        if (!this.asyncEventsEnabled && this.logMode === 'events') {
            this.logMode = 'services';
            this.eventEnvelopes = [];
            this.eventSummary = { total: 0, sources: {}, severities: {}, topics: {} };
            this.eventTopics = [];
        }
        if (!this.selectedSource && this.logSources.length > 0) this.selectedSource = this.logSources[0].id;
    }

    public async setLogMode(mode: string) {
        if (mode === 'events' && !this.asyncEventsEnabled) return;
        this.logMode = mode;
        if (this.isServiceMode()) {
            const exists = this.visibleServices.some((item: any) => item.name === this.selectedService);
            if (!exists) {
                this.selectedService = '';
                this.logs = [];
                this.serviceView = 'logs';
                this.serviceYaml = '';
            }
        }
        await this.service.render();
        if (this.isServiceMode()) await this.loadOperationQueueSummary();
        if (mode === 'sources' && this.sourceLogs.length === 0) await this.loadSourceLogs();
        if (mode === 'events' && this.eventEnvelopes.length === 0) await this.loadEvents();
    }

    public isServiceMode() {
        return this.logMode === 'services' || this.logMode === 'dockers';
    }

    public get visibleServices() {
        if (this.logMode === 'dockers') {
            return this.services.filter((item: any) => item.runtime === 'docker');
        }
        return this.services.filter((item: any) => item.runtime !== 'docker');
    }

    public async selectService(name: string) {
        this.selectedService = name;
        this.serviceView = 'logs';
        this.logs = [];
        this.serviceYaml = '';
        await this.service.render();
        await this.loadLogs();
    }

    public selectedServiceInfo() {
        return this.services.find((item: any) => item.name === this.selectedService) || {};
    }

    public isSelectedDockerService() {
        return this.selectedServiceInfo().runtime === 'docker';
    }

    public async setServiceView(view: string) {
        this.serviceView = view;
        await this.service.render();
        if (view === 'yaml' && this.serviceYaml === '') {
            await this.loadServiceYaml();
        }
    }

    public async loadLogs() {
        if (!this.selectedService) return;
        this.serviceView = 'logs';
        this.loadingLogs = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("service_logs", {
                service: this.selectedService,
                lines: this.logLines
            });
            if (code === 200) this.logs = data.logs || [];
        } catch (e) { }
        this.loadingLogs = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public async loadServiceYaml() {
        if (!this.selectedService || !this.isSelectedDockerService()) return;
        this.loadingYaml = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("service_yaml", {
                service: this.selectedService
            });
            if (code === 200) this.serviceYaml = data.yaml || '';
            else this.serviceYaml = data.message || 'Failed to load Docker YAML.';
        } catch (e) {
            this.serviceYaml = `Error: ${e}`;
        }
        this.loadingYaml = false;
        await this.service.render();
    }

    public async selectSource(sourceId: string) {
        this.selectedSource = sourceId;
        this.sourceLogs = [];
        this.sourceFiles = [];
        this.sourceMessage = '';
        await this.service.render();
        await this.loadSourceLogs();
    }

    public async applyPreset(preset: any) {
        if (preset && preset.event_source) {
            if (!this.asyncEventsEnabled) return;
            this.eventSourceFilter = preset.event_source;
            this.logMode = 'events';
            await this.loadEvents();
            return;
        }
        if (preset && preset.sources && preset.sources.length > 0) {
            this.selectedSource = preset.sources[0];
            this.logMode = 'sources';
            await this.loadSourceLogs();
        }
    }

    public async loadEvents() {
        if (!this.asyncEventsEnabled) return;
        this.loadingLogs = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("event_envelopes", {
                limit: this.logLines,
                node_id: this.nodeFilter,
                trace_id: this.eventTraceFilter,
                topic: this.eventTopicFilter,
                source: this.eventSourceFilter,
                severity: this.eventSeverityFilter
            });
            if (code === 200) {
                this.asyncEventsEnabled = data?.log_policy?.async_events !== false;
                if (!this.asyncEventsEnabled) {
                    this.logMode = 'services';
                    this.eventEnvelopes = [];
                    this.eventSummary = { total: 0, sources: {}, severities: {}, topics: {} };
                    this.eventTopics = [];
                    this.loadingLogs = false;
                    await this.service.render();
                    return;
                }
                this.eventEnvelopes = data.events || [];
                this.eventSummary = data.summary || { total: 0, sources: {}, severities: {}, topics: {} };
                this.eventTopics = data.topics || [];
            }
        } catch (e) { }
        this.loadingLogs = false;
        await this.service.render();
    }

    public async loadSourceLogs() {
        if (!this.selectedSource) return;
        this.loadingLogs = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("log_source_tail", {
                source: this.selectedSource,
                lines: this.logLines,
                node_id: this.nodeFilter,
                deployment_job_id: this.deploymentJobFilter
            });
            if (code === 200) {
                this.sourceLogs = data.logs || [];
                this.sourceFiles = data.files || [];
                this.sourceMessage = data.message || '';
            }
        } catch (e) { }
        this.loadingLogs = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public get filteredSourceLogs() {
        if (this.levelFilter === 'all') return this.sourceLogs;
        return this.sourceLogs.filter(l => l.level === this.levelFilter);
    }

    public selectedSourceTitle() {
        const item = this.logSources.find(s => s.id === this.selectedSource);
        return item ? item.title : this.selectedSource;
    }

    public get filteredLogs() {
        if (this.levelFilter === 'all') return this.logs;
        return this.logs.filter(l => l.level === this.levelFilter);
    }

    public eventSeverityClass(severity: string): string {
        switch (severity) {
            case 'error': return 'bg-red-100 text-red-700 border-red-200';
            case 'warning': return 'bg-amber-100 text-amber-700 border-amber-200';
            case 'debug': return 'bg-zinc-100 text-zinc-600 border-zinc-200';
            default: return 'bg-emerald-100 text-emerald-700 border-emerald-200';
        }
    }

    public getStatusBadge(status: string): string {
        switch (status) {
            case 'active': case 'running': return 'bg-green-100 text-green-700';
            case 'inactive': case 'stopped': return 'bg-zinc-100 text-zinc-500';
            case 'failed': return 'bg-red-100 text-red-700';
            case 'planned': return 'bg-sky-100 text-sky-700';
            case 'not-installed': return 'bg-zinc-100 text-zinc-500';
            default: return 'bg-yellow-100 text-yellow-700';
        }
    }

    public getStatusDot(status: string): string {
        switch (status) {
            case 'active': case 'running': return 'bg-green-500';
            case 'inactive': case 'stopped': return 'bg-zinc-400';
            case 'failed': return 'bg-red-500';
            case 'planned': return 'bg-sky-500';
            case 'not-installed': return 'bg-zinc-300';
            default: return 'bg-yellow-500';
        }
    }

    public getRuntimeBadgeClass(runtime: string): string {
        if (runtime === 'docker') return 'bg-sky-100 text-sky-700 border-sky-200';
        return 'bg-zinc-100 text-zinc-500 border-zinc-200';
    }

    public getLevelColor(level: string): string {
        switch (level) {
            case 'error': return 'text-red-400';
            case 'warning': return 'text-yellow-400';
            case 'debug': return 'text-zinc-400';
            default: return 'text-zinc-300';
        }
    }

    public queueStatusCount(status: string): number {
        const statuses = this.operationQueueSummary.statuses || {};
        return statuses[status] || 0;
    }

    public get attentionTasks(): any[] {
        return this.operationQueueSummary.latest_attention || [];
    }

    public async controlService(serviceName: string, action: string) {
        if (!confirm(this.translate.instant('page.logs.confirm_control', { service: serviceName, action }))) return;
        try {
            const { code, data } = await wiz.call("service_control", {
                service: serviceName,
                action: action
            });
            if (code === 200) {
                await this.loadServices(true);
                if (this.selectedService === serviceName) {
                    setTimeout(() => this.loadLogs(), 1500);
                }
            } else {
                alert(data.message || `Failed to ${action}`);
            }
        } catch (e) {
            alert(`Error: ${e}`);
        }
    }

    public toggleAutoRefresh() {
        this.autoRefresh = !this.autoRefresh;
        if (this.autoRefresh) {
            this.startAutoRefresh();
        } else {
            this.stopAutoRefresh();
        }
        this.service.render();
    }

    private startAutoRefresh() {
        this.stopAutoRefresh();
        this.refreshTimer = setInterval(() => {
            if (this.selectedService) this.loadLogs();
        }, 5000);
        this.statusTimer = setInterval(() => {
            this.loadServices();
            this.loadOperationQueueSummary();
        }, 30000);
    }

    private stopAutoRefresh() {
        if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; }
    }

    private stopStatusTimer() {
        if (this.statusTimer) { clearInterval(this.statusTimer); this.statusTimer = null; }
    }

    public async downloadLog(serviceName: string) {
        const url = `/wiz/api/page.kiera.logs/download_logs`;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        form.target = '_blank';
        const addField = (name: string, value: string) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
        };
        addField('service', serviceName);
        addField('lines', '5000');
        const csrfCookie = document.cookie.split(';')
            .map((value: string) => value.trim())
            .find((value: string) => value.indexOf('KIERA_CSRF=') === 0);
        if (csrfCookie) addField('kiera_csrf', csrfCookie.substring('KIERA_CSRF='.length));
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    private scrollToBottom() {
        setTimeout(() => {
            const el = document.querySelector('.log-viewer-scroll');
            if (el) el.scrollTop = el.scrollHeight;
        }, 100);
    }
}

export default PageKieraLogsComponent;
